<template>
    <div>
        <div class="header-full">
          <div class="logo-login">
              <img :src="require('@/assets/img/logo.png')" alt/>
          </div>
        </div>
        <router-view></router-view>
        <div class="footer-full">
            <div class="logo-login">
                <img :src="require('@/assets/img/logo-footer.png')" alt/>
            </div>
            <div class="info-footer">
                <p>日本最大級のエンタメ特化のマッチングプラットフォーム</p>
                <p>Copyright©Backstage All rights Reserved.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'full-layout',
        mounted() {
        }
    }
</script>

<style scoped>

</style>
